import type { Components, Theme } from '@mui/material/styles'

import { borderWidth, fontSize, spacing } from '@/themes/tokens'

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    navBack: true
  }
}

export const MuiButtonOverride: Components<Theme>['MuiButton'] = {
  defaultProps: {
    variant: 'contained',
    size: 'medium',
  },
  styleOverrides: {
    root: {
      borderRadius: 8,
      textTransform: 'none',
      fontSize: fontSize.base,
    },
    contained: {
      color: '#ffffff',
      boxShadow: 'none',
      minWidth: 'auto',
      '&:hover': {
        boxShadow: '0 0 16px 0 rgba(0, 113, 255, 0.24)',
      },
    },
    outlined: {
      borderWidth: borderWidth.thin,
    },
    text: ({ theme }) => ({
      color: theme.palette.text.primary,
      minWidth: 'auto',
    }),
  },
  variants: [
    {
      props: { size: 'small' },
      style: ({ theme }) => ({
        paddingLeft: theme.spacing(spacing.md),
        paddingRight: theme.spacing(spacing.md),
        paddingTop: theme.spacing(spacing.xs),
        paddingBottom: theme.spacing(spacing.xs),
      }),
    },
    {
      props: { size: 'medium' },
      style: ({ theme }) => ({
        paddingLeft: theme.spacing(spacing.input),
        paddingRight: theme.spacing(spacing.input),
        paddingTop: theme.spacing(1.25),
        paddingBottom: theme.spacing(1.25),
      }),
    },
    {
      props: { size: 'large' },
      style: ({ theme }) => ({
        paddingLeft: theme.spacing(spacing.lg),
        paddingRight: theme.spacing(spacing.lg),
        paddingTop: theme.spacing(spacing.md),
        paddingBottom: theme.spacing(spacing.md),
      }),
    },
    {
      props: { variant: 'text', size: 'medium' },
      style: ({ theme }) => ({
        paddingLeft: theme.spacing(spacing.md),
        paddingRight: theme.spacing(spacing.md),
      }),
    },
    {
      props: { variant: 'text', size: 'small' },
      style: ({ theme }) => ({
        paddingLeft: theme.spacing(spacing.md),
        paddingRight: theme.spacing(spacing.md),
      }),
    },
    {
      props: { variant: 'text', size: 'large' },
      style: ({ theme }) => ({
        paddingLeft: theme.spacing(spacing.md),
        paddingRight: theme.spacing(spacing.md),
      }),
    },
    {
      props: { variant: 'navBack' },
      style: ({ theme }) => ({
        justifyContent: 'flex-start',
        color: theme.palette.text.secondary,
        fontWeight: 400,
        paddingLeft: theme.spacing(spacing.sm),
        paddingRight: theme.spacing(spacing.sm),
        marginBottom: theme.spacing(spacing.md),
      }),
    },
  ],
}
